import { IPlayerChannel } from "../../interfaces/player/IPlayerUIState.ts";
import { Orientation } from "../../consts/orientation.ts";
import PlayerEpgPrevious from "./PlayerEpgPrevious.tsx";
import { LazyLoadImage } from "react-lazy-load-image-component";
import PlayerEpgItem from "./PlayerEpgItem.tsx";
import { PlayCircleIcon } from "@heroicons/react/24/solid";
import PlayerEpgNext from "./PlayerEpgNext.tsx";
import { useContext } from "react";
import { AppMainStateContext } from "../../contexts/AppMainStateContext.tsx";
import { useAppDispatch, useAppSelector } from "../../stores/store.ts";
import { playerUIActions } from "./playerUISlice.ts";
import { changeVideoAsync } from "./playerSlice.ts";
import { usePlayerPage } from "../../hooks/usePlayerPage.tsx";

interface IProps {
    channel: IPlayerChannel,
    className?: string
}

const PlayerChannel = ({ channel, className }: IProps) => {
    const dispatch = useAppDispatch();
    const { isMobile, orientation } = useContext(AppMainStateContext);
    const { handleTouchMove } = usePlayerPage();
    const selectedEpgIndex = useAppSelector(store => store.playerUI.actualEpgIndex);
    const lastOperationType = useAppSelector(store => store.playerUI.lastOperationType);

    const handleClickChangeVideo = async (channel: IPlayerChannel) => {
        await dispatch(changeVideoAsync({ chId: channel.ch_id }));
    };

    return (
        <div
            key={channel.ch_id}
            data-id={channel.ch_id}
            className={`${isMobile &&
                (orientation === Orientation.PORTRAIT_PRIMARY ||
                    orientation === Orientation.PORTRAIT_SECONDARY)
                ? "space-x-2 md:space-x-4 mx-0 md:mx-4 mr-0"
                : "space-x-6 xl:space-x-10 mx-2"
                } 
            ${lastOperationType === "CHANGE_CHANNEL_UP" && "playerChannel-scrollUpAnimation"} 
            ${lastOperationType === "CHANGE_CHANNEL_DOWN" && "playerChannel-scrollDownAnimation"} 
            flex items-center ${isMobile ? "py-0 sm:py-2" : "py-2"} ${className}`}
            onAnimationEnd={() => {
                dispatch(playerUIActions.setLastOperationType("NONE"))
            }}
            onTouchStart={handleTouchMove}
            onTouchEnd={handleTouchMove}
        >
            <PlayerEpgPrevious epg={channel.epgList[selectedEpgIndex - 1]} firstElemId={channel.firstEpgId} />
            <LazyLoadImage
                alt=""
                effect="opacity"
                className="grow align-middle"
                wrapperClassName={`flex items-center w-12 sm:w-16 md:w-20 shrink-0`}
                src={`${import.meta.env.VITE_MIX_CHANNEL_LOGO_URL}/${channel.logo}`}
            />
            <div className={"flex flex-col grow overflow-hidden"}>
                <div className={"flex flex-col text-base md:text-xl truncate"}>
                    <p className={"text-neutral-200 font-light truncate"}>{channel.name}</p>
                    <PlayerEpgItem
                        index={1}
                        key={1}
                        epg={channel.epgList[selectedEpgIndex]}
                        channelName={channel.name}
                    />
                </div>
            </div>
            <button
                className={"focus:outline-none hidden sm:block"}
                onClick={async () => {
                    await handleClickChangeVideo({ ...channel, cmd: channel.cmd })
                }}
            >
                <PlayCircleIcon className={`${isMobile ? "w-8 h-8" : "w-12 h-12"} text-[#008DD2]`} />
            </button>
            <PlayerEpgNext epg={channel.epgList[selectedEpgIndex + 1]} lastEpgId={channel.lastEpgId} />
        </div>
    );
};

export default PlayerChannel;